import { Injectable } from '@angular/core';

interface TutorialState {
  dismissed: boolean;
}

@Injectable({ providedIn: 'root' })
export class TutorialService {
  private key(userId: string | null | undefined, area: string) {
    const uid = userId || 'anon';
    return `tutorial_${uid}_${area}`;
  }

  shouldShow(userId: string | null | undefined, area: string): boolean {
    const raw = localStorage.getItem(this.key(userId, area));
    if (!raw) return true;
    try {
      const state = JSON.parse(raw) as TutorialState;
      return !state.dismissed;
    } catch {
      return true;
    }
  }

  dismiss(userId: string | null | undefined, area: string) {
    localStorage.setItem(this.key(userId, area), JSON.stringify({ dismissed: true }));
  }

  reset(userId: string | null | undefined, area: string) {
    localStorage.removeItem(this.key(userId, area));
  }
}
